import React from "react";
import PropTypes from "prop-types";
import { Form, Input, Select } from "antd";
import { useGetAllEmployeesQuery } from "../../service/employeeService";
function AddModalBalanceDetail({ selectedData, file, setFile }) {
  const { data } = useGetAllEmployeesQuery();
  const empList = data && data ? data : [];
  const { Option } = Select;
  const value = false;

  return (
    <div>
      <div className="flex w-full">
        <Form.Item
          className="w-1/2 mr-2"
          name="reportingManager"
          label="Reporting Manager"
        >
          <Select placeholder="Reporting Manager">
            {empList?.map((doc) => {
              return (
                <Option value={doc._id} key={doc._id}>
                  {doc.firstName} {doc.lastName}
                </Option>
              );
            })}
          </Select>
        </Form.Item>

        <Form.Item
          className="w-1/2 mr-2"
          name="joiningDate"
          label="Joining Date"
          rules={[
            {
              required: true,
              message: "Please enter your Joining Date",
            },
          ]}
        >
          <Input
            type="date"
            className="w-full text-[13px]"
            placeholder="Joining Date"
            disabled={selectedData ? true : false}
          />
        </Form.Item>
      </div>
      <div className="flex w-full">
        {value ? (
          <Form.Item className="w-1/2 mr-2" label="Resume" value={file}>
            <input
              type="file"
              className="w-full"
              onChange={(e) => {
                setFile(e.target.files[0]);
              }}
            />
          </Form.Item>
        ) : (
          ""
        )}
      </div>
      <div className="flex mt-2 w-full">
        <Form.Item
          className="w-1/2 mr-2"
          name="aadhaarNumber"
          label="Aadhaar Number"
        >
          <Input
            placeholder="Aadhaar Number"
          />
        </Form.Item>
        <Form.Item
          className="w-1/2 mr-2"
          name="panNumber"
          label="PAN Number"
        >
          <Input
            placeholder="PAN Number"
          />
        </Form.Item>
      </div>
      <div className="flex mt-2 w-full">
        <Form.Item
          className="w-1/2 mr-2"
          name="bankName"
          label="Bank Name"
        >
          <Input
            placeholder="Bank Name"
          />
        </Form.Item>
        <Form.Item
          className="w-1/2 mr-2"
          name="bankAccountNumber"
          label="Bank Account Number"
        >
          <Input
            placeholder="Bank Account Number"
          />
        </Form.Item>
      </div>
      <div className="flex mt-2 w-full">
        <Form.Item
          className="w-1/2 mr-2"
          name="uanNumber"
          label="UAN Number"
        >
          <Input
            placeholder="UAN Number"

          />
        </Form.Item>
        <Form.Item
          className="w-1/2 mr-2"
          name="esiNumber"
          label="ESI Number"
        >
          <Input
            placeholder="ESI Number"
          />
        </Form.Item>
      </div>
    </div>
  );
}
AddModalBalanceDetail.propTypes = {
  file: PropTypes.object,
  setFile: PropTypes.func,
  selectedData: PropTypes.array,
};
export default AddModalBalanceDetail;
